import { buildLabel } from 'src/utilities/naming';

// Type of business options
export const SOLE_PROPRIETOR = 'Sole proprietor';
export const PARTNERSHIP = 'Partnership';
export const C_CORP = 'C-Corp';
export const S_CORP = 'S-Corp';
export const LLC = 'LLC';
export const CORP = 'Corp';

export const SOLE_PROPRIETOR_LABEL = buildLabel('sbappp_sole_proprietor');
export const PARTNERSHIP_LABEL = buildLabel('sbappp_partnership');
export const C_CORP_LABEL = buildLabel('sbappp_ccorp');
export const S_CORP_LABEL = buildLabel('sbappp_scorp');
export const LLC_LABEL = buildLabel('sbappp_llc');
export const NON_PROFIT_ORGANISATION = 'Non profits Organisations';
export const NON_PROFIT_ORGANISATION_LABEL = buildLabel(
  'non_profits_organisations'
);
export const NON_PROFIT_ORGANIZATION = 'Non Profit Organization';
export const NON_PROFIT_ORGANIZATION_LABEL = buildLabel(
  'non_profits_organizations'
);

export const LABEL_CONNECTOR = ', ';
export const PURPOSE_OF_LOAN = 'purpose_of_loan';
export const ADVISOR_ID = 'advisor';

// Type of business purpose options
export const PAYROLL = 'Payroll';
export const RENT_MORTGAGE_INTEREST = 'Lease/Mortgage Interest';
export const UTILITIES = 'Utilities';
export const OTHERS = 'Others';

export const PAYROLL_LABEL = buildLabel('sbappp_payroll');
export const RENT_MORTGAGE_INTEREST_LABEL = buildLabel(
  'sbappp_rent_mortage_interest'
);
export const UTILITIES_LABEL = buildLabel('sbappp_utilities');
export const OTHERS_LABEL = buildLabel('sbappp_self_others');

export const BUSINESS_PURPOSE_MAP = {
  [PAYROLL_LABEL]: PAYROLL,
  [RENT_MORTGAGE_INTEREST_LABEL]: RENT_MORTGAGE_INTEREST,
  [UTILITIES_LABEL]: UTILITIES,
  [OTHERS_LABEL]: OTHERS,
};

export const DISPLAY_NAME_OWNER = 'Owner';
export const DISPLAY_NAME_CO_OWNER = 'Co-owner';